import { withStyles } from "@material-ui/core/styles";
import React from "react";
import NumberFormat from "react-number-format";
import { connect } from "react-redux";
const styles = (theme) => ({
  regular: {
    color: "rgb(110, 175, 15)",
  },
  warning: {
    color: "#ff513f",
  },
});
class PriceFomat extends React.Component {
  render() {
    let {
      classes,
      value,
      priceType = "regular",
      hideCurrencyCode = false,
    } = this.props;
    return (
      <div className={classes[priceType]}>
        <NumberFormat
          thousandSeparator={true}
          displayType={"text"}
          value={value}
        />
        {!hideCurrencyCode && ` ${this.props.currencyCode}`}
      </div>
    );
  }
}
const mapState = (state) => ({
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
});

const mapDispatch = (dispatch) => ({});
export default connect(mapState, mapDispatch)(withStyles(styles)(PriceFomat));
